import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentOrder: null,
};

export const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    setCurrentOrder: (state, action) => {
      state.currentOrder = action.payload;
    },
  },
});

export const { setCurrentOrder } = ordersSlice.actions;

export default ordersSlice.reducer;
